import { IMenuItem } from "./IMenuItem";


export class MenuItem implements IMenuItem {
  private id: string;
  private display: string;
  private state: string;
  private children: MenuItem[];
  private requiredPermission: string | undefined;
  private requiredRole: string | undefined;
  private anyPermission: string[] | undefined;
  private parent: MenuItem | undefined;
  private imgSrc: string | undefined;
  private activeOnState: string;
  private excludeActiveOnState: string | undefined;

  getId(): string {
    return this.id;
  }

  getParent(): MenuItem | undefined {
    return this.parent;
  }

  getDisplay(): string {
    return this.display;
  }

  getState(): string {
    return this.state;
  }

  getActiveOnState(): string {
    return this.activeOnState
  }

  getChildren(): MenuItem[] {
    return this.children;
  }

  getRequiredPermission(): string | undefined {
    return this.requiredPermission;
  }

  getRequiredRole(): string | undefined {
    return this.requiredRole
  }

  getAnyPermission(): string[] | undefined {
    return this.anyPermission
  }

  getImgSrc(): string | undefined {
    return this.imgSrc
  }

  getExcludeActiveOnState(): string | undefined {
    return this.excludeActiveOnState
  }

  addChild(child: MenuItem, order?: number) {
    const insertAt = order ?? this.children.length;
    const childsParent = child.getParent()

    if (childsParent) {
      const oldParentsChildren = childsParent.getChildren()
      const index = oldParentsChildren.indexOf(child)
      if (index > -1) {
        oldParentsChildren.splice(index, 1)
      }
    }

    this.children.splice(insertAt, 0, child);
    child.parent = this;
  }

  constructor(config: {
    id: string; display?:
    string; state: string;
    requiredPermission?: string;
    requiredRole?: string;
    children?: MenuItem[];
    imgSrc?: string,
    anyPermission?: string[],
    activeOnState?: string,
    excludeActiveOnState?: string
  }) {
    this.id = config.id;
    this.display = config.display ?? this.id;
    this.state = config.state;
    this.activeOnState = config.activeOnState ?? config.state;
    this.requiredPermission = config.requiredPermission;
    this.requiredRole = config.requiredRole;
    this.children = [];
    config.children?.forEach(c => this.addChild(c));
    this.imgSrc = config.imgSrc;
    this.anyPermission = config.anyPermission
    this.excludeActiveOnState = config.excludeActiveOnState
  }
}
